import React, { useState, useEffect, useRef } from 'react';
import { FaCog } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Topbar({ isSidebarOpen }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const closeDropdown = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };

  const handleResize = () => {
    setIsMobileView(window.innerWidth < 768);
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeDropdown);
    window.addEventListener('resize', handleResize);
    return () => {
      document.removeEventListener('mousedown', closeDropdown);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className='topbar'
      style={{
        position: 'fixed',
        top: 20,
        left: isMobileView ? 7 : isSidebarOpen ? '280px' : '100px',
        right: isMobileView ? 0 : 20,
        width: isMobileView ? '97%' : 'auto',
        backgroundColor: '#342EAD',
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        padding: isMobileView ? '8px 30px':'8px 20px',
        borderRadius: isMobileView ? '8px' : '10px',
        transition: 'left 0.3s ease',
        boxShadow: isSidebarOpen
          ? 'none'
          : '0 4px 10px rgba(0, 0, 0, 0.3)',
        zIndex: 1000,
      }}
    >
      <div
        className="icons"
        style={{ display: 'flex', gap: '20px', alignItems: 'center' }}
      >
        {/* Dropdown Menu */}
        <div style={{ position: 'relative' }} ref={dropdownRef}>
          <FaCog className='icon-topbar'
            style={{
              fontSize: '1.2rem',
              color: isDropdownOpen ? '#ffffff99' : '#fff',
              cursor: 'pointer',
            }}
            onClick={toggleDropdown}
          />
          {isDropdownOpen && (
            <div
              style={{
                position: 'absolute',
                top: '35px',
                right: 0,
                backgroundColor: '#fff',
                color: '#000',
                borderRadius: '5px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                zIndex: 10,
              }}
            >
              <ul
                style={{
                  listStyle: 'none',
                  margin: 0,
                  padding: '10px 0',
                  width: '200px',
                }}
              >
                <li
                  style={{
                    padding: '5px 15px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#666cff';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#000';
                  }}
                  onClick={() => setIsDropdownOpen(false)}
                >
                  <Link
                    to="/dashboard/setting"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Tenant Settings
                  </Link>
                </li>
                <li
                  style={{
                    padding: '5px 15px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#666cff';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#000';
                  }}
                  onClick={() => setIsDropdownOpen(false)}
                >
                  <Link
                    to="/dashboard/billing-detail"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                  </Link>
                </li>
                <li
                  style={{
                    padding: '5px 15px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#666cff';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#000';
                  }}
                  onClick={() => setIsDropdownOpen(false)}
                >
                  <Link
                    to="/dashboard/connected-accounts"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Connected Accounts
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* User Avatar */}
        {/* <div className='Avatar'
          style={{
            width: '45px',
            height: '45px',
            borderRadius: '50%',
            backgroundColor: '#fff',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#333',
          }}
        >
          <span>M</span>
        </div> */}
      </div>
    </div>
  );
}

export default Topbar;
